export const puppeteerInitArgs = [
  '--no-sandbox',
  '--disable-setuid-sandbox',
  '--disable-web-security',
  // '--incognito',
  '--disable-infobars',
  '--ignore-certificate-errors',
  '--ignore-certificate-errors-spki-list',
  '--disable-sync',
  '--disable-software-rasterizer',
  // '--proxy-server="http://116.80.47.48:3172"',
  // '--disable-features=IsolateOrigins,site-per-process',
  // '--disable-blink-features=AutomationControlled',
];

export const CHROME = {
  Windows: 'C:\\Program Files\\Google\\Chrome\\Application\\chrome.exe',
  Linux: '/usr/bin/chromium',
  Mac: '/Applications/Google Chrome.app/Contents/MacOS/Google Chrome',
};
export const LOGTO_DOMAIN = 'https://logto.ksr.la';
export const LOGTO_RESOURCE = 'https://bandai.ksr.la';
export const LOGTO_APPID = '8pi6uon8emks9sd46yf56';

export enum LogtoPermission {
  ADMIN = 'admin',
  ACC_CREATE = 'account:create',
  ACC_READ = 'account:read',
  ACC_WRITE = 'account:write',
  ACC_DELETE = 'account:delete',
  SESSION_START = 'session:start',
  SESSION_STOP = 'session:stop',
  SESSION_CREATE = 'session:create',
  SESSION_UPDATE = 'session:write',
  SESSION_READ = 'session:read',
  SESSION_DELETE = 'session:delete',
  AGENT_CREATE = 'agent:create',
  AGENT_UPDATE  = 'agent:write',
  AGENT_READ = 'agent:read',
  AGENT_DELETE = 'agent:delete',
  ACTION_READ = 'action:read',
  ACTION_UPDATE = 'action:write',
  ACTION_CREATE = 'action:create',
  ACTION_DELETE = 'action:delete',
  ACTION_PUBLISH = 'action:publish',
  RESOURCE_MANAGE = 'resource:manage',
}